import { useContext } from 'react';
import { CounterContext } from '../contexts';

export const useCounter = () => {
  return useContext(CounterContext);
};
